/**
 * Report task status updates — Phase 5b replacement.
 * Delegates to /api/reports/{reportId}/tasks/{taskId} on dash-api.
 */

import {getApiBase} from '../../config/apiBase';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token
        ? {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json'}
        : {'Content-Type': 'application/json'};
}

export async function setReportTaskStatus(reportId, taskId, status) {
    if (!reportId) throw new Error('setReportTaskStatus: reportId is required');
    if (!taskId) throw new Error('setReportTaskStatus: taskId is required');
    if (!status) throw new Error('setReportTaskStatus: status is required');

    const resp = await fetch(
        `${getApiBase()}/reports/${encodeURIComponent(reportId)}/tasks/${encodeURIComponent(taskId)}`,
        {
            method: 'PATCH',
            headers: authHeaders(),
            body: JSON.stringify({status}),
        }
    );
    if (!resp.ok) throw new Error(`setReportTaskStatus ${resp.status}`);

    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('report-tasks-changed', {detail: {reportId, taskId, status}}));
    }
}
